import { render } from "./PerformanceReview.vue?vue&type=template&id=28b5b604&scoped=true"
import script from "./PerformanceReview.vue?vue&type=script&lang=js"
export * from "./PerformanceReview.vue?vue&type=script&lang=js"

import "./PerformanceReview.vue?vue&type=style&index=0&id=28b5b604&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/PROD/okr-web-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28b5b604"]])

export default __exports__